export default __webpack_public_path__ + "static/media/pet-breeds.c5eb4ee8.png";